import { useState, useRef } from "react";
import FormDropDown from "../../../forms/DropDownList/FormDropDown";
import Toggle from "../../../forms/Toggle/Toggle";
import "./ClawResultTriggers.scss";

const ClawWinResultTriggers = (props) => {
    const winTriggers = props.customisationData?.triggerOptions?.inGameTriggers?.winnerTrigger ?? [];
    const defaultOptionsList = [
        {label: 'Play All Selected', value: -2},
        {label: 'Choose Random From Selected', value: -1},
    ];
    /* const selectedOptionsList = [
        {label: 'Default', value: -1},
        {label: 'Skip', value: -2},
    ];
    winTriggers.forEach((trigger, index) => {
        defaultOptionsList.push({label: trigger.name && trigger.name.length > 0 ? trigger.name : `Trigger ${index + 1}`, value: index});
        selectedOptionsList.push({label: trigger.name && trigger.name.length > 0 ? trigger.name : `Trigger ${index + 1}`, value: index});
    }); */

    console.log('Win Triggers props: ', props);
    let receivedData = props.passedInPreviewData?.resultControl ?? props.featureVars?.resultControl ?? {};
    console.log('Win Result Triggers Received Data', receivedData);
    const defaultTriggerValue = receivedData.defaultWinTrigger ?? -1;
    // const selectedTriggerValue = receivedData.selectedWinTrigger ?? -1;

    const defaultTriggerIndex = defaultOptionsList.findIndex(option => option.value === defaultTriggerValue);
    // const selectedTriggerIndex = selectedOptionsList.findIndex(option => option.value === selectedTriggerValue);

    const skipSelected = receivedData?.skipWinTriggers === true;

    const resetToDefault = () => {
        props.changeValFunc("resultControl", "selectedWinTriggers", winTriggers.map(trigger => trigger.playAsDefault === true));
        props.changeValFunc("resultControl", "skipWinTriggers", false);
    }

    return (
        <>
            <div className="fc-column">
                <div className={`feature-control-holder fc-expanded`}>
                    <div className={`fl-row`}>
                        <div className="form-field-content label no-bottom-margin">Skip Win Triggers This Turn</div>
                        <div className="grow-100"></div>
                        <Toggle id={`winTriggerToggle_skip`} currentState={skipSelected} toggleFunc={(e, id) => {receivedData.skipWinTriggers = !skipSelected; props.changeValFunc("resultControl", "skipWinTriggers", receivedData.skipWinTriggers);}} variant='compact' />
                    </div>
                </div>
            </div>
            <div className="fc-column">
                <div className={`feature-control-holder fc-expanded`}>
                    <div className="fl-row" style={{opacity: skipSelected ? 0.25 : 1}}>
                        <FormDropDown
                            className={'wide-select'}
                            label="Win Trigger Behaviour"
                            id="defaultWinTrigger"
                            selectFunc={(e, id, item) => {props.changeValFunc("resultControl", "defaultWinTrigger", item.val ?? item.value);}}
                            items={defaultOptionsList}
                            currentIndex={defaultTriggerIndex}
                            showErrors={false}
                            enabled={!skipSelected}
                        />
                    </div>
                </div>
            </div>
            <div className="fc-column">
                <div className={`feature-control-holder fc-expanded`}>
                    <div class="info-text light-text" style={{opacity: skipSelected ? 0.25 : 1}}>Toggle Win Triggers on and off below. The highlighted options are the ones that will play by default.</div>
                </div>
            </div>
            <div className="fc-column">
                <div className={`feature-control-holder fc-expanded`}>
                    {winTriggers.map((trigger, index) => {
                        const value = receivedData.selectedWinTriggers ? receivedData.selectedWinTriggers[index] : false;
                        let highLightClass = '';
                        if (trigger.playAsDefault) {
                            if (value === true) {
                                highLightClass = ' on';
                            } else {
                                highLightClass = ' off';
                            }
                        }

                        return (
                            <div key={index} className={`fl-row claw-controls-default-trigger${highLightClass}`} style={{opacity: skipSelected ? 0.25 : 1}}>
                                <div className="form-field-content label no-bottom-margin">{trigger.name}</div>
                                <div className="grow-100"></div>
                                <Toggle 
                                    id={`winTriggerToggle_${index}`} 
                                    currentState={value} 
                                    toggleFunc={(e, id) => {receivedData.selectedWinTriggers[index] = !value; props.changeValFunc("resultControl", "selectedWinTriggers", receivedData.selectedWinTriggers);}} 
                                    variant='compact' 
                                    enabled={!skipSelected}
                                />
                            </div>
                        )
                    })}
                    {/* <div className="fl-row">
                        <FormDropDown
                            className={'wide-select'}
                            label="Select Next Win Trigger"
                            id="selectNextWinTrigger"
                            selectFunc={(e, id, item) => {props.changeValFunc("resultControl", "selectedWinTrigger", item.val ?? item.value);}}
                            items={selectedOptionsList}
                            currentIndex={selectedTriggerIndex}
                            showErrors={false}
                            enabled={true}
                        />
                    </div> */}
                </div>
            </div>
            <div className="fc-column">
                <div className={`feature-control-holder fc-expanded`}>
                    <button class="standard-button" style={{minWidth: '100%'}} onClick={resetToDefault}><div class="fl-row">Reset Win Triggers To Default</div></button>
                </div>
            </div>
        </>
    )
}

export default ClawWinResultTriggers;
